<!--
  ~ Copyright (c) 2020. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <https://veneliniliev.com>
  -->

<div ngbDropdown class="d-inline-block" *ngIf="saleId">
  <button class="btn btn-sm btn-outline-primary" id="email-templates-dropdown" ngbDropdownToggle>
    {{ 'EMAIL_TEMPLATES_BUTTON.SEND_EMAIL' | translate }}
  </button>
  <div ngbDropdownMenu aria-labelledby="email-templates-dropdown">
    <button ngbDropdownItem (click)="openEmailTemplateSender(templatesTypes.SALEGENERAL)">
      {{ 'EMAIL_TEMPLATES_BUTTON.GENERAL' | translate }}
    </button>
    <button ngbDropdownItem (click)="openEmailTemplateSender(templatesTypes.SALECLIENTOFFER)">
      {{ 'EMAIL_TEMPLATES_BUTTON.OFFERS' | translate }}
    </button>
    <button ngbDropdownItem (click)="openEmailTemplateSender(templatesTypes.SALEWEBOFFERS)">
      {{ 'EMAIL_TEMPLATES_BUTTON.WEB_OFFERS' | translate }}
    </button>
    <button ngbDropdownItem (click)="openEmailTemplateSender(templatesTypes.SALEINVOICES)">
      {{ 'EMAIL_TEMPLATES_BUTTON.INVOICES' | translate }}
    </button>
    <button ngbDropdownItem (click)="openEmailTemplateSender(templatesTypes.SALEVOUCHERS)">
      {{ 'EMAIL_TEMPLATES_BUTTON.VOUCHERS' | translate }}
    </button>
    <button ngbDropdownItem (click)="openEmailTemplateSender(templatesTypes.SALEFEEDBACK)">
      {{ 'EMAIL_TEMPLATES_BUTTON.FEEDBACK' | translate }}
    </button>
    <button ngbDropdownItem (click)="openEmailTemplateSender(templatesTypes.SALESENDTERMS)">
      {{ 'EMAIL_TEMPLATES_BUTTON.SEND_TERMS' | translate }}
    </button>
    <button ngbDropdownItem (click)="openEmailTemplateSender(templatesTypes.SALEAUTOCAMPAIGN)">
      {{ 'EMAIL_TEMPLATES_BUTTON.AUTO_CAMPAIGN' | translate }}
    </button>
  </div>
</div>
